<app-header></app-header>
<app-about></app-about>
<app-startups></app-startups>
<app-investors></app-investors>
<app-contact></app-contact>
<app-footer></app-footer>